import angular from 'angular';
import '../core.module';

function registerAuthGuard($transitions) {
  $transitions.onBefore({ to: 'app.**' }, (transition) => {
    const SessionService = transition.injector().get('SessionService');
    if (!SessionService.isAuthenticated()) {
      return transition.router.stateService.target('auth.login');
    }
    if (SessionService.user && SessionService.user.mustChangePassword) {
      return transition.router.stateService.target('auth.login');
    }
    return undefined;
  });
}

registerAuthGuard.$inject = ['$transitions'];

angular.module('app.core').run(registerAuthGuard);

export default registerAuthGuard;
